import { render } from "./JobReview.vue?vue&type=template&id=3af89213&scoped=true"
import script from "./JobReview.vue?vue&type=script&lang=js"
export * from "./JobReview.vue?vue&type=script&lang=js"

import "./JobReview.vue?vue&type=style&index=0&id=3af89213&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/deguild-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3af89213"]])

export default __exports__